import { MngBaseModelRegistry } from '@mng/model-ui';
import { MgsFieldStringComponent } from '../ui/field/mgs-field-string.component';
import { MgsFieldBooleanComponent } from '../ui/field/mgs-field-boolean.component';
import { MgsFieldMultilistComponent } from '../ui/field/mgs-field-multilist.component';
import { MgsFieldShortstringComponent } from '../ui/field/mgs-field-shortstring.component';
import { ATTRIBUT_TYPES } from '@mng/mgs-lib';
import { MgsFieldNumericComponent } from '../ui/field/mgs-field-numeric.component';
import { MgsFieldListComponent } from '../ui/field/mgs-field-list.component';

export class MgsFieldRegistry extends MngBaseModelRegistry<any> {
  constructor() {
    super();

    this.setDefaultItem(MgsFieldShortstringComponent);

    this.register(`${ATTRIBUT_TYPES.TYPE_BOOLEAN}`, MgsFieldBooleanComponent);
    this.register(`${ATTRIBUT_TYPES.TYPE_STRING}`, MgsFieldStringComponent);
    this.register(`${ATTRIBUT_TYPES.TYPE_SHORTSTRING}`, MgsFieldShortstringComponent);
    this.register(`${ATTRIBUT_TYPES.TYPE_MULTILIST}`, MgsFieldMultilistComponent);
    this.register(`${ATTRIBUT_TYPES.TYPE_MULTILISTYEAR}`, MgsFieldMultilistComponent);
    this.register(`${ATTRIBUT_TYPES.TYPE_LIST}`, MgsFieldListComponent);
    this.register(`${ATTRIBUT_TYPES.TYPE_NUMERIC}`, MgsFieldNumericComponent);
    this.register(`${ATTRIBUT_TYPES.TYPE_DECIMAL}`, MgsFieldNumericComponent);
  }
}
